export default __webpack_public_path__ + "svg/map/Ciudades-icex.svg?be976f8f";